import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

/**
 * Sets the document title to "${title} | Voxist AI Dev Portal"
 * If title is empty, sets it to just "Voxist AI Dev Portal"
 */
export function usePageTitle(title: string) {
  useEffect(() => {
    document.title = title ? `${title} | Voxist AI Dev Portal` : 'Voxist AI Dev Portal';
  }, [title]);
}

/**
 * Syncs the <html lang> attribute with the current i18n language
 */
export function useLanguageSync() {
  const { i18n } = useTranslation();
  useEffect(() => {
    document.documentElement.lang = i18n.language || 'en';
  }, [i18n.language]);
}
